<template>
  <ul class="tweet-list" ref="tweet-list" @scroll="onScrollList">
    <li v-if="loading" class="loading-box">
      LOADING...
      <loading-bar></loading-bar>
    </li>
    <li class="tweet" ref="tweets" v-for="(tw, index) in twimgs" :key="tw.id_str" :style="{
      width: boxWidthCss,
      height: boxHeightCss
    }">
      <tweet-box ref="tweet-boxes"
        :visible="index <= dispMax && index >= dispMin"
        :imgsrc="tw.imgsrc + ':thumb'"
        :statusid="tw.statusid"
        :mindex="tw.mindex"
        :stockid="tw.stockid || null"
        ></tweet-box>
    </li>
  </ul>
</template>

<style scoped>
  ul{
    position: relative;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
    -webkit-backface-visibility:hidden;
    backface-visibility:hidden;
    text-align: left;
  }
  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 0;
  }
  .tweet {
    display: inline-block;
    width: 50%;
    height: 120px;
    position: relative;
  }
  .loading-box{
    color: gray;
    width: 100%;
    padding-top: 100px;
    text-align: center;
    font-size: 13pt;
  }
</style>

<script>
import UserApi from '@/api/UserApi'
import TwApi from '@/api/TwApi'
import StockApi from '@/api/StockApi'
import TweetBox from '@/components/TweetBox'
import LoadingBar from '@/components/LoadingBar'

const API_MY = 'my'
const API_FAV = 'favs'

export default {
  name: 'TweetList',
  components: {TweetBox, LoadingBar},
  props: {
    initialPos: Number,
    listType: String
  },
  data () {
    return {
      tweets: [],
      dispMax: 10,
      dispMin: 0,
      loading: true,
      scrollHandleId: 0,
      lastScroll: {top: -100, left: 0}
    }
  },
  computed: {
    twimgs () {
      const imgs = []
      const tws = this.$data.tweets
      tws.forEach(tw => {
        if (tw.sid) {
          imgs.push({
            imgsrc: tw.imgsrc,
            statusid: tw.statusid,
            mindex: tw.mindex,
            stockid: tw.sid
          })
        } else {
          const medias = tw['extended_entities'].media
          imgs.push(...medias.map((m, index) => {
            return {
              imgsrc: m['media_url_https'],
              statusid: tw.id_str,
              mindex: index,
              stockid: null
            }
          }))
        }
      })
      return imgs
    },
    boxXCount () {
      const baseWidthPx = 150
      const w = this.$refs['tweet-list'].clientWidth
      const unitCount = Math.max(1, Math.floor(w / baseWidthPx))
      return unitCount
    },
    boxWidthCss () {
      return `${100 / this.boxXCount}%`
    },
    boxHeight () {
      const w = this.$refs['tweet-list'].clientWidth
      return Math.floor(w / this.boxXCount)
    },
    boxHeightCss () {
      return this.boxHeight + 'px'
    }
  },
  methods: {
    onScrollList () {
      const SCROLL_MARGIN = 2
      const THRESHOLD = 20
      const ul = this.$el
      const isOverThreshold = Math.abs(this.$data.lastScroll.top - ul.scrollTop) > THRESHOLD
      if (!isOverThreshold) { return }
      this.$data.lastScroll.top = ul.scrollTop

      const top = ul.scrollTop
      const btm = top + ul.clientHeight
      const boxCountTop = (Math.ceil(top / this.boxHeight) - SCROLL_MARGIN) * this.boxXCount
      const boxCountBtm = (Math.ceil(btm / this.boxHeight) + SCROLL_MARGIN) * this.boxXCount
      this.$data.dispMin = Math.max(0, boxCountTop)
      this.$data.dispMax = boxCountBtm - 1
    },
    getScrollPos () {
      return this.$data.lastScroll
      // {top: this.$el.scrollTop, left: 0}
    },
    loadList (type) {
      if (type === 'stocks') {
        this._loadStocks()
      } else {
        this._loadTweets()
      }
    },
    _loadStocks () {
      UserApi.getToken().then((tk) => {
        this.loading = true
        this.$data.tweets = []
        StockApi.getStocks().then(stocks => {
          this.$data.tweets = stocks
          this.$data.loading = false
          Promise.resolve().then(() => {
            this.$el.scrollTop = this.$props.initialPos || 0
            this.onScrollList() // update visible area
          })
        })
      })
    },
    _loadTweets () {
      UserApi.getToken().then((tk) => {
        this.loading = true
        this.$data.tweets = []
        const token = tk.twToken
        const secret = tk.twSecret
        const apiName = this.listType === 'favs' ? API_FAV : API_MY
        // const onLoad = (tws) => {
        //   this.$data.tweets = [...tws.tweets]
        //   this.$data.loading = false
        // }
        TwApi[apiName](token, secret, null).then((tws) => {
          this.$data.tweets = [...tws.tweets]
          this.$data.loading = false
          Promise.resolve().then(() => {
            this.$el.scrollTop = this.$props.initialPos || 0
            this.onScrollList() // update visible area
          })
        })
      })
    }
  },
  watch: {
    listType (newVal) {
      if (newVal) {
        this.loadList(newVal)
      }
    }
  },
  mounted () {
    if (this.listType) {
      this.loadList(this.listType)
    }
  },
  activated () {
    this.$el.scrollTop = this.$el.scrollTop || this.$props.initialPos || 0
    this.onScrollList() // update visible area
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TweetList.vue